import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  ExpandOutlined,
  CompressOutlined,
  PushpinOutlined,
  PushpinFilled,
} from '@ant-design/icons';

import { useAssistant } from './AssistantProvider';
import { SparkIcon, PlusIcon, HistoryIcon, CloseIcon } from './icons';

/* Panel header: spark avatar, title, connection status subline, action buttons. */
const Header = () => {
  const { t } = useTranslation('assistant');
  const {
    reconnecting,
    setOpen,
    newChat,
    showList,
    listView,
    fullScreen,
    toggleFullScreen,
    pinned,
    togglePinned,
  } = useAssistant();

  return (
    <div className="bra-hd">
      <span className="bra-hava">
        <SparkIcon />
      </span>
      <div>
        <div className="bra-htitle">{t('Assistant')}</div>
        <div className="bra-hsub">
          <span className={`bra-dot${reconnecting ? ' bra-warn' : ''}`} />
          <span>{reconnecting ? t('Reconnecting…') : t('Online')}</span>
        </div>
      </div>
      <div className="bra-hbtns">
        <button
          type="button"
          className="bra-ibtn"
          title={t('New chat')}
          aria-label={t('New chat')}
          onClick={newChat}
        >
          <PlusIcon />
        </button>
        <button
          type="button"
          className="bra-ibtn"
          title={t('Conversations')}
          aria-label={t('Conversations')}
          onClick={() => showList(!listView)}
        >
          <HistoryIcon />
        </button>
        <button
          type="button"
          className="bra-ibtn"
          title={
            pinned
              ? t('Unpin — float over the page')
              : t('Pin — dock beside the page')
          }
          aria-label={
            pinned
              ? t('Unpin — float over the page')
              : t('Pin — dock beside the page')
          }
          aria-pressed={pinned}
          style={pinned ? { color: '#01689b' } : undefined}
          onClick={togglePinned}
        >
          {pinned ? <PushpinFilled /> : <PushpinOutlined />}
        </button>
        <button
          type="button"
          className="bra-ibtn"
          title={fullScreen ? t('Exit full screen') : t('Full screen')}
          aria-label={fullScreen ? t('Exit full screen') : t('Full screen')}
          onClick={toggleFullScreen}
        >
          {fullScreen ? <CompressOutlined /> : <ExpandOutlined />}
        </button>
        <button
          type="button"
          className="bra-ibtn"
          title={t('Close')}
          aria-label={t('Close')}
          onClick={() => setOpen(false)}
        >
          <CloseIcon />
        </button>
      </div>
    </div>
  );
};

export default Header;
